import { Enumeration } from '../../../utils/AppEnum';

export class AWSPortOpeningRequestsTypes extends Enumeration<AWSPortOpeningRequestsTypes> {

    // eslint-disable-next-line react/static-property-placement
    public displayName: string;

    constructor(name?: string, value?: number, displayName?: string) {
        super(name, value);
        this.displayName = displayName;
    }

    public static AccountToInternet = new AWSPortOpeningRequestsTypes('AccountToInternet', 0, 'Account -> Internet');

    public static AccountToDMZ = new AWSPortOpeningRequestsTypes('AccountToDMZ', 1, 'Account -> DMZ');

    public static Untrusted = new AWSPortOpeningRequestsTypes('Untrusted', 2, 'Untrusted');
}
